import env from "@beam-australia/react-env";

// staging/dev only: shows the employer signup form without a signup link or partner route
export const openEmployerSignup = () => env("OPEN_EMPLOYER_SIGNUP") === "true";
